import { SystemPermissionType } from '@juvare/contact-management/backend/features/permissions/shared';

export const localAdminAnnouncementsPermissions: SystemPermissionType[] = [];
export const localAdminContactManagementPermissions: SystemPermissionType[] = [
    'list-all-accounts-for-organization',
    'manage-accounts-organizations',
    'import-accounts',
    'view-group-history',
    'view-organizations',
    'export-accounts',
    'log-in',
    'view-user-directory',
    'manage-profile-picture',
];
export const localAdminMissionsPermissions: SystemPermissionType[] = [
    'manage-all-admin-missions',
    'allow-self-withdraw',
    'manage-time-tracking',
];
export const localAdminCredentialingPermissions: SystemPermissionType[] = ['download-forms', 'request-license-check', 'view-screenings'];
export const localAdminNotificationsPermissions: SystemPermissionType[] = [];

export const localAdminPermissions: SystemPermissionType[] = [
    ...localAdminAnnouncementsPermissions,
    ...localAdminContactManagementPermissions,
    ...localAdminMissionsPermissions,
    ...localAdminCredentialingPermissions,
    ...localAdminNotificationsPermissions,
];
